export function getNormalizedEmail(email?: string | null): string {
    return email?.trim().toLowerCase() ?? '';
}

export function getIsCurrentUserEmail(email: string | null | undefined, currentUserEmails: string[]): boolean {
    const normalizedEmail = getNormalizedEmail(email);
    return normalizedEmail !== '' && currentUserEmails.includes(normalizedEmail);
}
